"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("g", {
    id: "more*"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.29853 8.87389C8.90794 8.87389 9.40197 8.37986 9.40197 7.77044C9.40197 7.16102 8.90794 6.66699 8.29853 6.66699C7.68911 6.66699 7.19508 7.16102 7.19508 7.77044C7.19508 8.37986 7.68911 8.87389 8.29853 8.87389Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.43646 8.87389C5.04587 8.87389 5.5399 8.37986 5.5399 7.77044C5.5399 7.16102 5.04587 6.66699 4.43646 6.66699C3.82704 6.66699 3.33301 7.16102 3.33301 7.77044C3.33301 8.37986 3.82704 8.87389 4.43646 8.87389Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.1606 8.87389C12.77 8.87389 13.264 8.37986 13.264 7.77044C13.264 7.16102 12.77 6.66699 12.1606 6.66699C11.5512 6.66699 11.0571 7.16102 11.0571 7.77044C11.0571 8.37986 11.5512 8.87389 12.1606 8.87389Z",
    fill: fill
  }))));
};

exports["default"] = _default;